export enum RoomMode {
  Undirectional = 'UNDIRECTIONAL',
  Bidirectional = 'BIDIRECTIONAL',
}

export type StreamCreateRoomRequestDto =
  | {
      mode: RoomMode.Undirectional;
      deviceId: string;
    }
  | {
      mode: RoomMode.Bidirectional;
      groupId: string;
    }
  | {
      mode: RoomMode.Bidirectional;
      deviceId: string;
    };
